import * as React from 'react';
export default function SvgWifi() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 18,
    r: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.5 14.563a4.231 4.231 0 012.5-.813c.934 0 1.798.302 2.5.813M16.713 11.228A8.212 8.212 0 0012 9.75a8.212 8.212 0 00-4.712 1.478M5 7.946a12.194 12.194 0 017-2.196c2.603 0 5.016.812 7 2.196"
  }));
}